export interface SkeletonProps {
  /** Tailwind size classes, e.g. "h-4 w-32". Shape it like the content it stands in for. */
  className?: string;
  rounded?: 'control' | 'card' | 'full';
}

const RADIUS = { control: 'rounded-control', card: 'rounded-card', full: 'rounded-full' } as const;

/** Loading placeholder. Never show a bare "Loading…" — always a shaped skeleton. */
export function Skeleton({ className = 'h-4 w-full', rounded = 'control' }: SkeletonProps) {
  return (
    <div aria-hidden className={`animate-pulse bg-surface-2 ${RADIUS[rounded]} ${className}`} />
  );
}

export function SkeletonLines({ lines = 3 }: { lines?: number }) {
  return (
    <div className="space-y-2" role="status" aria-label="Loading">
      {Array.from({ length: lines }, (_, index) => (
        <Skeleton key={index} className={index === lines - 1 ? 'h-4 w-2/3' : 'h-4 w-full'} />
      ))}
    </div>
  );
}
